import { render, staticRenderFns } from "./sopartcost.vue?vue&type=template&id=0059251c&scoped=true&"
import script from "./sopartcost.vue?vue&type=script&lang=js&"
export * from "./sopartcost.vue?vue&type=script&lang=js&"
import style0 from "./sopartcost.vue?vue&type=style&index=0&id=0059251c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059251c",
  null
  
)

export default component.exports